module.exports = __webpack_public_path__ + "static/media/palaischinois.b1fd1ede.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/SectionOne/illus/palaischinois.svg
// module id = 152
// module chunks = 0